import {useEffect, useRef} from 'react';
import {useInvisibleFrame} from '@stripe-internal/stripethirdparty';
import {
  ClientUrls,
  ObservabilityConfig,
} from '@stripe-internal/conversations-client';
import {ClientProvider} from '@stripe-internal/conversations-ui';
import {TwilioClient} from './client';
import {STPTwilio} from './stp';

const getBaseURL = () => {
  const {hostname} = window.location;
  if (hostname.includes('localhost')) {
    return 'http://localhost:8080';
  } else {
    const webpackHostname = hostname.replace(
      'stripethirdparty',
      'stripethirdparty_webpack',
    );
    return `https://${webpackHostname}`;
  }
};

export const TwilioClientProvider = ({
  baseURL = getBaseURL(),
  value,
  urls,
  observability,
  children,
}: {
  baseURL?: string;
  urls?: Partial<ClientUrls>;
  observability?: ObservabilityConfig;
  value?: TwilioClient;
  children: React.ReactNode;
}) => {
  const ref = useRef<TwilioClient>(
    value || new TwilioClient({urls, observability}),
  );
  const client = ref.current;

  const frame = useInvisibleFrame({
    baseURL,
    type: 'TwilioConversations',
    handleMessage: client.handleSTPEvent,
  });

  useEffect(() => {
    if (frame?.sendRequest) {
      client.initialize(new STPTwilio(frame?.sendRequest));
    }
  }, [client, frame]);

  return <ClientProvider value={client}>{children}</ClientProvider>;
};
